var _path, _path2, _path3, _g, _path4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8020_8777)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8020_8777",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8020_8777)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8020_8777)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8020_8777",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 9,
    height: 9
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2353 6H5V14.4615H13.2353V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8020_8777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5049 10.9362H7.73024C7.27929 10.9367 6.84696 11.1211 6.5281 11.4487C6.20923 11.7764 6.02984 12.2205 6.0293 12.6839V14.4619H12.2058V12.6839C12.2052 12.2205 12.0259 11.7764 11.707 11.4487C11.3881 11.1211 10.9559 10.9367 10.5049 10.9362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11741 10.2308C10.2545 10.2308 11.1763 9.2837 11.1763 8.11539C11.1763 6.94709 10.2545 6 9.11741 6C7.98036 6 7.05859 6.94709 7.05859 8.11539C7.05859 9.2837 7.98036 10.2308 9.11741 10.2308Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8020_8777",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 8,
    width: 9,
    height: 9
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 8.53845H10.7646V17H18.9999V8.53845Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8020_8777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2695 13.4746H13.4949C13.0439 13.4752 12.6116 13.6595 12.2928 13.9871C11.9739 14.3147 11.7945 14.7589 11.7939 15.2223V17.0003H17.9704V15.2223C17.9698 14.7589 17.7905 14.3147 17.4716 13.9871C17.1527 13.6595 16.7205 13.4752 16.2695 13.4746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8825 12.7692C16.0196 12.7692 16.9413 11.8221 16.9413 10.6539C16.9413 9.4855 16.0196 8.53845 14.8825 8.53845C13.7455 8.53845 12.8237 9.4855 12.8237 10.6539C12.8237 11.8221 13.7455 12.7692 14.8825 12.7692Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8020_8777",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8020_8777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersShort);
export default __webpack_public_path__ + "static/media/Users-Short.9f86f5b1ffab02b335b736c5c0ed2df5.svg";
export { ForwardRef as ReactComponent };